import http from 'plugins/axios';

export default {
  getSourceAddress(){
    return http.get({
      url:'/la/admin/coin/address-source/list'
    })
  },
  getChains(){
    return http.get({
      url:'/la/admin/coin/chain/list'
    })
  },
  getUdList(){
    return http.get({
      url:'/la/admin/coin/ud/coin'
    })
  },
  getCurrencyList({ code, page, size, areaType }) {
    return http.post({
      url: '/la/admin/coin/list',
      data: {
        code,
        page,
        size,
        areaType
      },
      dataType: 'form'
    });
  },
  updateDepositStatus({ coinType, status ,chain}) {
    return http.post({
      url: `/la/admin/coin/update/${coinType}/deposit/${status}?chain=${chain}`,
     
    });
  },
  updateWithdrawStatus({ coinType, status,chain }) {
    return http.post({
      url: `/la/admin/coin/update/${coinType}/withdraw/${status}?chain=${chain}`
    });
  },
  createCurrency(data) {
    return http.post({
      url: '/la/admin/coin/create',
      data
    });
  },
  updateCurrency(data) {
    return http.post({
      url: '/la/admin/coin/update',
      data
    });
  },
  removeCurrency({code,chain}) {
    return http.post({
      url: '/la/admin/coin/remove',
      data: {
        code,chain
      },
      dataType: 'form'
    });
  },
  updateTradeStatus({ coinType,chain, status }) {
    return http.post({
      url: `/la/admin/coin/update/${coinType}/trade/${status}?chain=${chain}`
    });
  },
  updateDisplayStatus({ coinType,chain, status }) {
    return http.post({
      url: `/la/admin/coin/update/${coinType}/display/${status}?chain=${chain}`
    });
  },
  updateAreaType({ coinType, type,chain }) {
    return http.post({
      url: `/la/admin/coin/update/${coinType}/areaType/${type}?chain=${chain}`
    });
  },
  updateSort({ coinType, orderNo,chain }) {
    return http.post({
      url: `/la/admin/coin/update/${coinType}/sort`,
      data: {
        coinType,
        orderNo,
        chain
      },
      dataType: 'form'
    });
  },
  detail({coinType,chain}) {
   
    return http.get({
      url: `/la/admin/coin/detail?coinType=${coinType}&chain=${chain}`,
      
    });
  },
  getCoinLogoInfo() {
    return http.get({
      url: '/la/admin/coin/logo'
    });
  },
  updateCoinLogoInfo(data) {
    return http.post({
      url: '/la/admin/coin/logo/update',
      data
    });
  },
  updateRedPacketStatus(data) {
    return http.post({
      url: `/la/admin/coin/red-packet/status/update`,
      data,
      dataType: 'form'
    });
  }
};
